import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { type CalendarApi } from "@fullcalendar/core"
import { Button, Flex, Typography } from "antd"
import React from "react"


const { Title } = Typography

interface CalendarNavigationProps {
  getAPI: () => CalendarApi | null | undefined
  onTodayClick: () => void
  onPrevClick: () => void
  onNextClick: () => void
}

export function CalendarNavigation({
  getAPI,
  onTodayClick,
  onPrevClick,
  onNextClick
}: CalendarNavigationProps) {
  const title = getAPI()?.view?.title || "Loading..."

  return (
    <Flex wrap gap={"small"} className={"pb-1"} align={"center"}>
      <Flex className={"shrink-0"}>
        <Flex gap={"middle"} align={"center"}>
          <Button
            type={"text"}
            icon={<LeftOutlined className={"font-bold stroke-3"} />}
            onClick={onPrevClick}
          />
          <Title className={"mb-0"} level={4}>
            {title}
          </Title>
          <Button
            type={"text"}
            icon={<RightOutlined />}
            onClick={onNextClick}
          />
        </Flex>
        <Button onClick={onTodayClick}>Today</Button>
      </Flex>
    </Flex>
  )
}
